import {RestService} from "@/services/rest/RestService";
import {ContentBlockEndpointsApi} from "@/api/pharma-cms-content-block";
import {ContentBlockResponseRestDto, TextWithImageContentRestDto} from "@/api/pharma-cms-content-block/models";
import {AxiosResponse} from "axios";
import {isValidButton} from "@/helpers/functions/content_blocks/validation";

export class ContentBlockRestService extends RestService {
    private apiService: ContentBlockEndpointsApi;

    protected constructor() {
        super();
        this.apiService = new ContentBlockEndpointsApi(this.getDpAxiosV2Instance(), undefined, this.getApiGwUrl('/pharma-cms'));
    }

    public async createNormalContentBlockTextWithImage(type: string, dto: TextWithImageContentRestDto): Promise<string | null> {
        const cb: TextWithImageContentRestDto = JSON.parse(JSON.stringify(dto)) as TextWithImageContentRestDto;

        cb.button = isValidButton(cb.button) ? cb.button : null;

        const response: AxiosResponse<ContentBlockResponseRestDto> = await this.apiService.createNormalContentBlockTextWithImage(cb, type);
        return response.data.id ?? null;
    }

    public async updateNormalContentBlockTextWithImage(type: string, id: string, dto: TextWithImageContentRestDto): Promise<void> {
        const cb: TextWithImageContentRestDto = JSON.parse(JSON.stringify(dto)) as TextWithImageContentRestDto;

        cb.button = isValidButton(cb.button) ? cb.button : null;

        await this.apiService.updateNormalContentBlockTextWithImage(cb, type, id);
    }
}
